<template>
    <div class="home-welcome-sec" style="background-image: url('../img/Header_Pis_1920px_x_880px_1_ver_full.jpg')">
        <div class="container">
            <div class="home-welcome-search-sec">
                <b-form @submit.stop.prevent="onSubmit" @reset="onReset" id="home-search-form">
                    <div class="input-group home-search__input-group">

                        <input type="text" v-model="q" class="form-control" placeholder="Унесите појам за претрагу"
                               id="home-search"
                               name="home-search">
                        <div class="input-group-append">
                            <button class="btn btn-home-search btn-home-refresh" data-input_to_refresh="home-search"
                                    type="reset" id="home_search_refresh">
                                <span class="icon-refresh-cw"></span>
                            </button>
                            <button class="btn btn-home-search " type="submit" id="button-home-search">
                                <span class="icon-search"></span>
                            </button>
                        </div>

                    </div>
                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    // import axios from 'axios';

    export default {
        name: "HomeWelcomeSec",
        data() {
            return {
                q: null,
                // q_response: null,
            }
        },
        props:[
          'searchQuery'
        ],
        methods: {

            onSubmit(evt) {
                evt.preventDefault();
                this.$router.push({path: 'unifiedSearch', query: {q: this.q}});

                // const path = `/unifiedSearch?${this.q}`;
                // if (this.$route.path !== path) this.$router.push(path)

            },
            onReset(evt) {

                evt.preventDefault();

                if(this.$router.history.current.path !== '/'){
                    this.$router.push({path: 'unifiedSearch', query: {q: 'null'}});
                    this.$emit('searchResultChange', null);
                }


                this.q = '';
                // this.q_response = null;
            },
        },
        mounted() {
            if(this.searchQuery){
                this.q=this.searchQuery;
              console.log(this.searchQuery);
            }
        }
    }
</script>

<style scoped>
    .input-group {

        box-shadow: none;
    }
</style>
